import React from 'react';
import { ColumnDataProps, RowDataProps } from '../props/tables';
type RowContent = React.ReactElement<any, any> | React.ReactNode;

export const DeleteConfirmationText = (type: string) => (
  <>
    Are you sure you want to <strong> permanently delete </strong> this {type}? This action cannot be undone.
  </>
)

export const renderHeight = (windowHeight: number, rows?: number) => {
  if (!rows) {
    return 0;
  }

  const rowHeight = 53;
  const headerRowHeight = 57;
  const tableHeight = Math.min(windowHeight, ((rows * rowHeight) + headerRowHeight));
  const maxHeight = windowHeight - 275;

  if (tableHeight >= maxHeight) {
    return maxHeight;
  }

  return tableHeight;
};

/** renders icons in cells, can potentially be used/optimized for a data-table */
export function renderRowContentType(row: RowDataProps, column: ColumnDataProps): RowContent {
  const { render, dataKey, amount } = column;
  switch (true) {
    case amount:
      return (row[dataKey] as string[]).length;
    case !!render:
      return render!(row);
    default:
      return row[column.dataKey];
  }
}